import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import AgGridTable from '../../utilities/AgGridTable';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Button, IconButton, TextField } from '@mui/material';
import { useCallback } from 'react';
import FamilyDetail from './document-component/FamilyDetail';
import DocumentsDetail from './document-component/DocumentsDetail';
import EductionDetail from './document-component/EductionDetail';

/*--------------------------------Accordion-------------------------------------*/

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

/*------------------------------------------------------------------------------------*/

const DocumentComponent = forwardRef((props, ref) => {
    const refDatePicker = useRef();
    const [error, setError] = useState("")
    const [validUntil, setValidUntil] = useState(null);
    const [documentFile, setDocumentFile] = useState([]);
    const [documentName, setDocumentName] = useState([]);

    const handleDocumentChange = (e) => {
        const file = e.target.files[0];
        setDocumentName(file.name);

        var reader = new FileReader();
        reader.onload = function (upload) {
            setDocumentFile(upload.target.result);
        };
        reader.readAsDataURL(file);
    }

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return documentName;
            }
        };
    });

    return (

        <IconButton component="label">
            <input hidden accept="image/*" type="file" onChange={(e) => handleDocumentChange(e)} />
            <CloudUploadIcon color="warning" />
        </IconButton>

        // <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
        //     <InputLabel htmlFor="outlined-adornment-password">
        //         Upload
        //     </InputLabel>
        //     <OutlinedInput
        //         id="outlined-adornment-password"
        //         endAdornment={
        //             <InputAdornment position="end">
        //                 <IconButton component="label">
        //                     <input hidden accept="image/*" type="file" onChange={(e) => handleDocumentChange(e)} />
        //                     <CloudUploadIcon color="warning" />
        //                 </IconButton>
        //             </InputAdornment>
        //         }
        //         value={documentName}
        //         label="Upload"
        //     />
        // </FormControl>

        // <Button
        //     variant="contained"
        //     component="label"
        //     color="warning"
        //     className='ml-12'
        // >
        //     <input hidden multiple type="file" onChange={(e) => console.log(e)} />
        //     <Typography color="black">Browse</Typography>
        // </Button>

    );

});

const docData = [
    { documentName: "Emirates ID", issueDate: "", expiryDate: "", attachFile: "" },
    { documentName: "Employment Visa", issueDate: "", expiryDate: "", attachFile: "" },
    { documentName: "Labor Card", issueDate: "", expiryDate: "", attachFile: "" },
    { documentName: "Driving License ", issueDate: "", expiryDate: "", attachFile: "" },
    { documentName: "Health Insurance Card", issueDate: "", expiryDate: "", attachFile: "" },
]

const Documents = forwardRef(({personalInfo,setSnackState ,setSuccessMsg, handleDocumentDisabled}, ref) => {
    const [expanded, setExpanded] = useState('panel1');
    const childRef = useRef();
    
    const handleChangePanel = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const handleDocumentSubmit = () => {
        const data = childRef.current;
        data.handleSubmit();
    }
    
    useImperativeHandle(ref, () => ({
        handleDocumentSubmit: handleDocumentSubmit,
      }));
    
    return (
        <div>
            <Accordion expanded={expanded === 'panel1'} onChange={handleChangePanel('panel1')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                    <Typography>Documents</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <DocumentsDetail ref={childRef} personalInfo={personalInfo} setSnackState={setSnackState} setSuccessMsg={setSuccessMsg} handleDocumentDisabled={handleDocumentDisabled}/>
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel2'} onChange={handleChangePanel('panel2')}>
                <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                    <Typography>Family Information</Typography>
                </AccordionSummary>
                <AccordionDetails>
                        <FamilyDetail personalInfo={personalInfo} setSnackState={setSnackState} setSuccessMsg={setSuccessMsg}/>
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel3'} onChange={handleChangePanel('panel3')}>
                <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                    <Typography>Education</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <EductionDetail personalInfo={personalInfo} setSnackState={setSnackState} setSuccessMsg={setSuccessMsg}/>
                </AccordionDetails>
            </Accordion>
        </div>
    )
})

export default Documents